import State from './state';

export function setChildRewards(state, data) {
  let aux = state.child_rewards;
  state.child_rewards = {};
  state.child_rewards = aux;
  state.child_rewards[data.id] = data.data;
}

export function setParentRewards(state, data) {
  let aux = state.parent_rewards;
  state.parent_rewards = {};
  state.parent_rewards = aux;
  state.parent_rewards[data.id] = data.data;
}

export function setParentPoints(state, parentPoints) {
  state.parent_points = parentPoints || 0;
}

export function setIsDuplicateActivate(state, newValue) {
  state.isDuplicateActivate = newValue;
}

export function setRewardIdeas(state = State, rewards = []) {
  state.rewardsIdeas = [...rewards];
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = '';
}

export function error(state, error) {
  console.log('errorcatch', error);
  state.error = true;
  state.errorMessage = error;
}
